import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { RemoveListFromOrderBatchInput } from './RemoveListFromOrderBatchInput';
import { RemoveListFromOrderBatchOutput } from './RemoveListFromOrderBatchOutput';

export class RemoveListFromOrderBatchService extends HttpServiceBase {

  handle = (input: RemoveListFromOrderBatchInput): Promise<Result<RemoveListFromOrderBatchOutput> | null> => {
    const promise = this.http.put<Result<RemoveListFromOrderBatchOutput>, RemoveListFromOrderBatchInput>(`${this.baseUrlSislogApi}/v2/order/batch/remove/list`, input);
    return promise;
  }
}